import { render, staticRenderFns } from "./CompilationsScreen.vue?vue&type=template&id=33b77936"
import script from "./CompilationsScreen.vue?vue&type=script&lang=js"
export * from "./CompilationsScreen.vue?vue&type=script&lang=js"
import style0 from "./CompilationsScreen.vue?vue&type=style&index=0&id=33b77936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports